const catalogItem = item => {
  //customFields may come from backend as camel or snake
  const customFields = item.custom_fields ? [...item.custom_fields] : item.customFields ? [...item.customFields] : []
  return {
    abbreviation: item.abbreviation || 'V19',
    category: item.category || null,
    categoryName: item.categoryName || 'MISC',
    color: item.color || null,
    customFields,
    description: item.description || '',
    id: item.id,
    image_data: item.image_data || {},
    internal: item.internal || '0',
    isAvailable: item.isAvailable,
    lastReservation: item.lastReservation || null,
    name: item.name || '',
    notes: item.notes || [],
    reservation_buffer: item.reservation_buffer || null,
    reservation_length: item.reservation_length || null,
    status: item.status || ''
  }
}

const contrastingColor = backgroundColor => {
  // attribution
  // https://convertingcolors.com/blog/article/convert_hex_to_rgb_with_javascript.html

  if (typeof backgroundColor !== 'string' || backgroundColor?.substring(0, 1) !== '#') {
    return 'secondary'
  }
  const R = parseInt(backgroundColor.substr(1, 2), 16)
  const G = parseInt(backgroundColor.substr(3, 2), 16)
  const B = parseInt(backgroundColor.substr(5, 2), 16)
  const hsp = Math.sqrt(R * R * 0.241 + G * G * 0.691 + B * B * 0.068)
  return hsp > 220 ? 'primary' : 'secondary'
  // return hsp > 127.5 ? 'black' : 'white'
}

const dayOfWeekFromDate = (date, asName = false, nameShort = true) => {
  const dt = date && typeof date.getMonth === 'function' ? date : new Date(date)
  const dayOfWeek = dt.getDay()
  if (!asName) {
    return dayOfWeek
  }

  return dayOfWeekNameFromNum(dayOfWeek, nameShort)
}

const dayOfWeekNameFromNum = (day, short = true) => {
  const days = [
    { short: 'SUN', long: 'DAY' },
    { short: 'MON', long: 'MONDAY' },
    { short: 'TUE', long: 'TUESDAY' },
    { short: 'WED', long: 'WEDNESDAY' },
    { short: 'THU', long: 'THURSDAY' },
    { short: 'FRI', long: 'FRIDAY' },
    { short: 'SAT', long: 'SATURDAY' }
  ]
  const dayData = days?.[+day] || { short: '', long: '' }
  return short ? dayData.short : dayData.long
}

const statesAbv = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

const timeHuman = time => {
  if (!time) return ''
  const timeArr = time.split(':')
  let period = 'am'
  let hour = parseInt(timeArr['0'])
  let min = parseInt(timeArr['1'])
  if (hour >= 12) period = 'pm'
  if (hour > 12) hour = hour - 12
  if (hour === 0) hour = 12
  // return `${hour.toString().padStart(2, '0')}:${min
  //   .toString()
  //   .padStart(2, '0')}${period}`
  return `${hour.toString()}:${min.toString().padStart(2, '0')}${period}`
}

const timestampSql = (time, withTime = true) => {
  time = time && typeof time.getMonth === 'function' ? time : new Date(time)

  const adjDt = new Date(time.getTime() - time.getTimezoneOffset() * 60000)
  return withTime ? adjDt.toISOString().slice(0, 19).replace('T', ' ') : adjDt.toISOString().split('T')[0]
}

const timestampHuman = (timestamp, withYear = true, withTime = true) => {
  const asDate = timestamp && typeof timestamp.getMonth === 'function' ? timestamp : new Date(timestamp)
  let human = ''
  let D = asDate.getDate()
  if (D < 10) {
    D = D.toString().padStart(2, '0')
  }
  let M = asDate.getMonth() + 1
  if (M < 10) {
    M = M.toString().padStart(2, '0')
  }
  human = `${M}/${D}`
  if (withYear) {
    human = human + '/' + asDate.getFullYear()
  }
  if (withTime) {
    let h = asDate.getHours()
    let m = asDate.getMinutes()
    let ampm = 'AM'
    if (h >= 12) {
      if (h > 12) {
        h = h - 12
      }
      ampm = 'PM'
    }
    if (h === 0) {
      h = 12
    }
    if (m < 10) {
      m = m.toString().padStart(2, '0')
    }
    human = human + `  ${h}:${m} ${ampm}`
  }
  return human
}

export { catalogItem, contrastingColor, dayOfWeekFromDate, dayOfWeekNameFromNum, statesAbv, timeHuman, timestampHuman, timestampSql }
